import { useState, useEffect } from 'react';
import { Shield } from 'lucide-react';

const CONSENT_KEY = 'cookie_consent';

export function getConsent() {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(CONSENT_KEY);
}

export function setConsent(value) {
  localStorage.setItem(CONSENT_KEY, value);
  window.dispatchEvent(new Event('consent-changed'));
}

export function hasTrackingConsent() {
  return getConsent() === 'all';
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
  }, []);

  const accept = (type) => {
    setConsent(type);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-fade-in-up" data-testid="cookie-banner">
      <div className="bg-white border-t border-slate-200 shadow-lg">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 sm:py-5">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Shield className="w-6 h-6 text-[#0E518D] flex-shrink-0 mt-0.5 sm:mt-0 hidden sm:block" strokeWidth={1.5} />
            <div className="flex-1">
              <p className="text-sm text-slate-700 font-body leading-relaxed">
                Wir verwenden Cookies und Tracking-Technologien, um unsere Seite zu verbessern und Zugriffe zu analysieren. Mit "Alle akzeptieren" stimmen Sie der Nutzung von Statistik-, QR- und Affiliate-Tracking zu.
              </p>
            </div>
            <div className="flex gap-3 flex-shrink-0 w-full sm:w-auto">
              <button
                onClick={() => accept('necessary')}
                className="flex-1 sm:flex-initial px-4 py-2.5 text-sm font-body font-medium text-slate-700 border border-slate-300 rounded-sm hover:bg-slate-50 transition-colors"
                data-testid="cookie-necessary-btn"
              >
                Nur notwendige
              </button>
              <button
                onClick={() => accept('all')}
                className="flex-1 sm:flex-initial px-5 py-2.5 text-sm font-body font-medium text-white bg-[#0E518D] rounded-sm hover:bg-[#0B4171] transition-colors"
                data-testid="cookie-accept-all-btn"
              >
                Alle akzeptieren
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
